module.exports = __webpack_public_path__ + "img/title-2.f43d05e5.png";